import CostHTMLPreviewGeneralCostsSection from './CostHTMLPreviewGeneralCostsSection'
import CostHTMLPreviewGroupingSection from './CostHTMLPreviewGroupingSection'
import CostHTMLPreviewHeaderSection from './CostHTMLPreviewHeaderSection'
import CostHTMLPreviewGrandTotalSection from './CostHTMLPreviewGrandTotalSection'
import {ReportColumnsFormatCostOfWork} from 'constants'
import CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy from './CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy'
import CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy from './CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy'
import CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy from './CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy'
import CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy from './CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy'
import CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy from './CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy'
import CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy from './CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy'
import $ from 'jquery'

export default function CostHTMLPreviewGenerator() {}

CostHTMLPreviewGenerator.prototype.init = function()
{
    return this;
};

CostHTMLPreviewGenerator.prototype.generatePreviewTable = function( reportParameters )
{
    var table = document.createElement( "table" );
    table.className = "reportHtmlPreviewTable cost";
    var tBody = document.createElement( "tbody" );
    table.appendChild( tBody );

    var columnsStrategy = this.getColumnsStrategy( reportParameters );

    var groupingRowsCount = 3;
    var generalCostsSection = null;
    if( reportParameters.showLeaveTimeCosts || reportParameters.showOvertimeAddition )
    {
        generalCostsSection = new CostHTMLPreviewGeneralCostsSection().init( reportParameters.showLeaveTimeCosts, reportParameters.showOvertimeAddition, columnsStrategy );
        if( !reportParameters.showLeaveTimeCosts )
            groupingRowsCount += 3;
        if( !reportParameters.showOvertimeAddition )
            groupingRowsCount ++;
    }
    else
    {
        groupingRowsCount += 5;
    }

    var groupingSection = new CostHTMLPreviewGroupingSection().init(
            reportParameters.firstGroupingLevel,
            reportParameters.secondGroupingLevel,
            reportParameters.thirdGroupingLevel,
            columnsStrategy, groupingRowsCount
    );

    var headerSection = new CostHTMLPreviewHeaderSection().init( columnsStrategy );

    var grandTotalSection = new CostHTMLPreviewGrandTotalSection().init( columnsStrategy );

    headerSection.addRows( tBody );
    groupingSection.addRows( tBody );
    if( generalCostsSection )
        generalCostsSection.addRows( tBody );
    grandTotalSection.addRows( tBody );

    return table;
};

CostHTMLPreviewGenerator.prototype.getColumnsStrategy = function(reportParameters) {
    const showOthers = reportParameters.includeOtherUsersColumn
    const $reportPreviewPlaceholder = $("#reportPreviewPlaceholder")
    $reportPreviewPlaceholder.removeClass("resizeForScroll")

    if (reportParameters.columnsConfig === ReportColumnsFormatCostOfWork.USERS_ONLY) {
        if (reportParameters.showSpentTime || reportParameters.showUserRates) {
            return new CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy().init(
                {
                    timeFormat: reportParameters.timeFormat,
                    showSpentTime: reportParameters.showSpentTime,
                    showAverageRates: reportParameters.showAverageRates,
                    showUserRates: reportParameters.showUserRates,
                    showOthers: showOthers,
                }
            )
        } else {
            return new CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy().init(
                {
                    timeFormat: reportParameters.timeFormat,
                    showAverageRates: reportParameters.showAverageRates,
                    showOthers: showOthers,
                }
            )
        }
    } else if (reportParameters.columnsConfig === ReportColumnsFormatCostOfWork.GROUPS_ONLY) {
        if (reportParameters.showSpentTime || reportParameters.showAverageRates) {
            return new CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy().init(
                {
                    timeFormat: reportParameters.timeFormat,
                    showSpentTime: reportParameters.showSpentTime,
                    showAverageRates: reportParameters.showAverageRates,
                    showOthers: showOthers,
                }
            )
        } else {
            return new CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy().init(
                {
                    timeFormat: reportParameters.timeFormat,
                    showOthers: showOthers,
                }
            )
        }
    } else {
        if (reportParameters.showSpentTime || reportParameters.showUserRates) {
            if (reportParameters.showAverageRates
                && reportParameters.showSubtotalsByDepartments
                && reportParameters.showSpentTime
                && reportParameters.showUserRates
                && showOthers
            ) {
                $reportPreviewPlaceholder.addClass("resizeForScroll")
            }
            return new CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy().init(
                {
                    timeFormat: reportParameters.timeFormat,
                    showSpentTime: reportParameters.showSpentTime,
                    showAverageRates: reportParameters.showAverageRates,
                    showUserRates: reportParameters.showUserRates,
                    showSubtotals: reportParameters.showSubtotalsByDepartments,
                    showOthers: showOthers,
                }
            )
        } else {
            return new CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy().init({
                    timeFormat: reportParameters.timeFormat,
                    showAverageRates: reportParameters.showAverageRates,
                    showSubtotals: reportParameters.showSubtotalsByDepartments,
                    showOthers: showOthers,
                }
            )
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewGenerator.js